/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
//Import PageHeader
import PageHeader from "../../../components/PageHeader";
import { get, isEmpty } from "lodash";
import { DAY_OF_WEEKS } from "../../../constants/DAY";
import ToolTip from "../../../components/ToolTip/ToolTip";
import Calendar from "../../../components/Calendar/Calendar";
import { ColCard } from "../../../components/ContentLayout";
import { dateDayofWeekFormat } from "../../../utils/date";
import {
  createHolidays,
  deleteHolidays,
  getHolidaysCalendarList,
  getHolidaysList,
} from "../../../apis/holiday/holidays";
import { modifyHolidaysManager } from "../../../apis/holiday/holidays-manager";
import { getHolidaysManager } from "../../../apis/holiday/holidays-manager";
import useForm from "../../../hooks/useForm";
import { translation } from "../../../utils/translator";
import DatePicker from "../../../components/DatePicker";
import PerfectScrollbar from "react-perfect-scrollbar";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import systemAlert from "../../../utils/systemAlert";
import { classnames } from "../../../utils/text";
import { viewLoading } from "../../../utils/loading";
import Icon from "../../../components/Icon";
import XIcon from "../../../assets/images/icon/x-icon.svg";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { permissionCheck } from "../../../utils/permission";

const WorkScheduleHoliday = (props) => {
  const history = useHistory()
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const [event, setEvent] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [notPaidHoliday, setNotPaidHoliday] = useState([
    { day: "monday", isHoliday: false },
    { day: "tuesday", isHoliday: false },
    { day: "wednesday", isHoliday: false },
    { day: "thursday", isHoliday: false },
    { day: "friday", isHoliday: false },
    { day: "saturday", isHoliday: false },
    { day: "sunday", isHoliday: false },
  ]);
  const [weeklyHoliday, setWeeklyHoliday] = useState([
    { day: "monday", isHoliday: false },
    { day: "tuesday", isHoliday: false },
    { day: "wednesday", isHoliday: false },
    { day: "thursday", isHoliday: false },
    { day: "friday", isHoliday: false },
    { day: "saturday", isHoliday: false },
    { day: "sunday", isHoliday: false },
  ]);

  const [holidayDate, setHolidayDate] = useState('')
  const [holidayText, setHolidayText] = useState('')
  const [targetPermission, setTargetPermission] = useState(null)

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'HOLIDAY')
      setTargetPermission(permission)
      if (isEmpty(permission)) {
        permissionCheck(history, "HOLIDAY")
      }
    }
  }, [permissions])


  const _reset = () => {

    getHolidaysInfo()
    getCalendarData()
    setHolidayDate('')
    setHolidayText('')
  }
  const _createHolidays = async () => {
    if (!holidayDate) {
      systemAlert('날짜를 선택해주세요.')
      return
    }
    if (!holidayText) {
      systemAlert('휴일의 이름을 작성해주세요.')
      return
    }
    const form = {
      repeatType: "year",
      holidayType: "weeklyHoliday",
      date: holidayDate,
      title: holidayText,
      description: holidayText
    }
    viewLoading(true)
    try {
      await createHolidays(form)
      _reset()
    } catch (error) { }
    viewLoading(false)
  }

  const _deleteHolidays = (holidayIdx) => {
    systemAlert("사내 휴일 기준을 삭제하시겠습니까?", {
      buttons: [{
        label: '확인',
        onClick: () => {
          viewLoading(true)
          deleteHolidays(holidayIdx)
            .finally(() => {
              viewLoading(false)
              _reset()
            })
        }
      }, {
        color: 'line',
        label: '취소',
      }]
    })

  }
  // const [startDate, setStartDate] = useState(new Date());
  const [dateParams] = useState({
    range: {
      date: {
        from: `${new Date().getFullYear()}-01-01`,
        to: `${new Date().getFullYear()}-12-31`,
      },
    },
  });

  useEffect(() => {
    getCalendarData();
    getHolidaysInfo();
  }, [dateParams]);

  useEffect(() => {
    setForm({
      ...form,
      notPaidHoliday,
      weeklyHoliday,
    });
  }, [notPaidHoliday, weeklyHoliday]);

  // 캘린더 및 휴일 목록
  const getCalendarData = () => {
    getHolidaysCalendarList(dateParams)
      .then((res) => {
        const holidyList = res.data.holidays.map((holiday) => ({
          ...holiday,
          name: holiday.title,
          date: dateDayofWeekFormat(holiday.date, "MM.DD"),
        }));
        setHolidayList(holidyList);
        const calendarHolidayList = res.data.holidays.map((holiday) => ({
          title: holiday.title,
          start: new Date(holiday.date),
          className: "holiday",
        }));
        setEvent(calendarHolidayList);
      })
      .catch((err) => {
        console.error(err.response);
      });

    getHolidaysList().then((res) => {
      //console.log("사내휴일", res);
    });
  };

  // 공통 휴일 (주휴일, 휴무일, 법정공휴일 휴일처리 여부) api
  const getHolidaysInfo = () => {
    getHolidaysManager()
      .then((res) => {
        setForm({
          ...res.data,
          isAcceptPublicHoliday: res.data.isAcceptPublicHoliday ? "1" : "0",
        });
        setNotPaidHoliday(res.data.notPaidHoliday);
        setWeeklyHoliday(res.data.weeklyHoliday);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const _submit = (form) => {
    form.isAcceptPublicHoliday = form.isAcceptPublicHoliday === "1"
    modifyHolidaysManager(form).then(() => {
      getHolidaysInfo();
    });
  };

  const { form, setForm, handleOnChange, handleSubmit } = useForm(
    {
      isAcceptPublicHoliday: "",
      weeklyHoliday: [],
      notPaidHoliday: [],
    },
    _submit,
    {}
  );

  const LEGAL_HOLIDAYS = [
    {
      label: "휴일처리",
      value: "1",
    },
    {
      label: "휴일처리 안함",
      value: "0",
    },
  ];

  return (
    !isEmpty(targetPermission) && (
      <div className="WorkSchedule-holiday">
        <PageHeader title={"공통 휴일"} />
        <div className="hoiiday-wrap">
          <div className="holiday-list">
            <PerfectScrollbar>
              <p className="list-title">휴일</p>
              <ul className="holiday-ul">
                {holidayList.map((holiday, idx) => (
                  <li
                    className={classnames("holiday-li")}
                    key={idx}
                  >
                    <label className="holiday-date">{get(holiday, "date")}</label>
                    <label className="holiday-name">
                      {get(holiday, "name")}
                      {
                        !holiday.isPublic && targetPermission.level > 1 &&
                        <Icon
                          src={XIcon}
                          className={"delete-icon"}
                          onClick={() => {
                            if (!holiday.isPublic) _deleteHolidays(holiday.holidayIdx)
                          }}
                        ></Icon>
                      }
                    </label>

                  </li>
                ))}
              </ul>
            </PerfectScrollbar>
          </div>
          <div className="holiday-form">
            {/* 주휴일 */}
            <p className="form-title">주휴일</p>
            <ToolTip
              position="bottom"
              tooltiptext="주휴일이란 1주일 동안 개근한 근로자에게 1일의 유급휴일을 부여하는 것을 말합니다. 근로기준법은 1주 15시간 이상 일하는 근로자가 소정근로일을 개근하면 주휴일을 부여하도록 명시하고 있습니다(근로기준법 제55조). 주휴일은 통상 관공서가 휴무하는 일요일로 하지만, 다른 요일로 정해도 무방합니다. 다만, 주휴일은 근로계약서상 특정요일로 명시되어 있어야 합니다."
            />
            <div className="form-container">
              {weeklyHoliday.map(({ day, isHoliday }, index) => (
                <div className="form-wrap" key={index}>
                  <input
                    id={`weekly-holiday-${index}`}
                    className="day-of-week-checkbox"
                    type="checkbox"
                    name="weekly"
                    checked={isHoliday}
                    value={day}
                    onChange={(e) => {
                      const { checked } = e.target;
                      let newArray = [...weeklyHoliday];
                      newArray[index] = { day, isHoliday: checked };
                      setWeeklyHoliday(newArray);
                    }}
                    disabled={targetPermission.level === 1}
                  />
                  <label
                    htmlFor={`weekly-holiday-${index}`}
                    className="day-of-week-label"
                  >
                    {translation(DAY_OF_WEEKS, day, "fullName", "label")}
                  </label>
                </div>
              ))}
            </div>
            {/* 휴무일 */}
            <p className="form-title">휴무일</p>
            <ToolTip
              position="bottom"
              tooltiptext="휴무일은 소정 근로시간이 없는 날을 의미합니다. 해당 일에 근무 할 경우 근무하는 직원이 해당 주 40시간을 초과 근무 하였다면 연장근로수당만 계산됩니다."
            />
            <div className="form-container">
              {notPaidHoliday.map(({ day, isHoliday }, index) => (
                <div className="form-wrap" key={index}>
                  <input
                    id={`holidy-${index}`}
                    className="day-of-week-checkbox"
                    type="checkbox"
                    name="weekly"
                    value={day}
                    checked={isHoliday}
                    onChange={(e) => {
                      const { checked } = e.target;
                      let newArray = [...notPaidHoliday];
                      newArray[index] = { day, isHoliday: checked };
                      setNotPaidHoliday(newArray);
                    }}
                    disabled={targetPermission.level === 1}
                  />
                  <label
                    htmlFor={`holidy-${index}`}
                    className="day-of-week-label"
                  >
                    {translation(DAY_OF_WEEKS, day, "fullName", "label")}
                  </label>
                </div>
              ))}
            </div>
            {/* 법정공휴일 휴일처리 여부 */}
            <p className="form-title">법정공휴일 휴일처리 여부</p>
            <ToolTip
              position="bottom"
              tooltiptext={`법정공휴일이 휴무일과 겹칠 경우 해당일은\n휴일이 아닌 휴무일로 처리됩니다.`}
            />
            <div className="form-container">
              {LEGAL_HOLIDAYS.map(({ label, value }, index) => (
                <div className="form-wrap" key={index}>
                  <input
                    id={`legal-holiday-${index}`}
                    className="radio-btn"
                    type="radio"
                    name="isAcceptPublicHoliday"
                    checked={form.isAcceptPublicHoliday === value}
                    value={value}
                    onChange={handleOnChange}
                    disabled={targetPermission.level === 1}
                  />
                  <label
                    htmlFor={`legal-holiday-${index}`}
                    className="radio-label"
                  >
                    {label}
                  </label>
                </div>
              ))}
              {targetPermission.level > 1 && (
                <div className="btn-wrap clear mt-15 text-align-right">
                  <Button
                    color="line"
                    onClick={handleSubmit}
                  >
                    저장
                  </Button>
                </div>
              )}
            </div>
            {/* 휴일 등록 */}
            {targetPermission.level > 1 && (
              <>
                <p className="form-title">휴일 등록</p>
                <div className="submit-form">
                  <div className="form-wrap">
                    <label className="form-label">날짜</label>
                    <div className="form-input">
                      <DatePicker
                        onChange={(date) => {
                          setHolidayDate(date.datepicker[0])
                        }}
                      />
                    </div>
                  </div>
                  <div className="form-wrap">
                    <label className="form-label">휴일이름</label>
                    <div className="form-input">
                      <Input
                        placeholder="예) 창립기념일"
                        onChange={(e) => {
                          setHolidayText(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="btn-wrap clear text-align-right">
                    <Button
                      color="line"
                      onClick={_createHolidays}
                    >
                      등록
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <ColCard className="margin-top-32" cardBody={{ className: "p-0" }}>
          <Calendar event={event} />
        </ColCard>
      </div >
    ));
};

export default WorkScheduleHoliday;
